import styled from 'styled-components';
import tw, { classnames, position, flexWrap, padding, margin, borderColor, display, space, textAlign, alignItems, fontSize, textColor, fontWeight, width } from 'tailwindcss-classnames';

export const Container = styled.div.attrs({
    className: classnames(borderColor('dark:border-gray-700' as any), position('relative'), flexWrap('flex-wrap'), padding('pb-10'), margin('mb-8'))
})`border-bottom: 1px solid;`;

export const GroupSection = styled.div.attrs({
    className: classnames(position('relative'), display('flex'), space('space-x-2'), textAlign('text-left'), padding('pl-0', 'pr-4', 'pb-3', 'md:pt-0', 'pt-8'), alignItems('items-center'))
})``;

export const GroupTitle = styled.span.attrs({
    className: classnames(textColor('text-gpas-700' as any, 'dark:text-white' as any), fontSize('text-2xl'), fontWeight('font-bold'), padding('pb-2'))
})``;
export const GroupSubtitle = styled.span.attrs({
    className: classnames(textColor('text-gpas-700' as any, 'dark:text-gpas-200' as any))
})``;

export const ResourcesSection = styled.div.attrs({
    className: classnames(position('relative'), padding('py-0'), width('w-full'))
})``;

export const ResourceItemsSection = styled.div.attrs({
    className: classnames(position('relative'))
})``;

export const ResourceItem = styled.div.attrs({
    className: classnames(position('relative'))
})``;
